module.exports = __webpack_public_path__ + "static/img/reject.ac26036f.svg";